import { Grid } from "@material-ui/core";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import React from "react";
import { Bar } from "react-chartjs-2";
import constants from "../../constants";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "right",
    },
    title: {
      display: false,
    },
  },
};

function calculateTotalBySectorsAndSubcategory(sectors, subcategory, data) {
  return sectors.map((_sector) => {
    let result = data.filter(
      (_data) =>
        _data.subcategory === subcategory && _data.sector === _sector
    );
    return result.length > 0 ? result[0].total : [];
  });
}

const StatisticsDetailChart = (props) => {
  const [data, setData] = React.useState({ labels: [], datasets: [] });

  function generateData(apiData) {
    let labels = Array.from(new Set(apiData.map((item) => item.sector)));
    let dataLabels = Array.from(
      new Set(apiData.map((item) => item.subcategory))
    );
    let datasets = dataLabels.map((item, index) => {
      return {
        label: item,
        data: calculateTotalBySectorsAndSubcategory(labels, item, apiData),
        backgroundColor:
          constants.colors.length > index
            ? constants.colors[index]
            : constants.randColor(),
      };
    });

    setData({
      labels: labels,
      datasets: datasets,
    });
  }

  React.useEffect(() => {
    generateData(props.data);
  }, [props.data]);

  return (
    <Grid item xs={12}>
      <div
        style={{
          minHeight: "50vh",
          padding: "5vh",
          width: "100%",
          minWidth: "720px",
        }}
      >
        <Bar options={options} data={data} />
      </div>
    </Grid>
  );
};

export default StatisticsDetailChart;
